import { objectValues } from 'src/app/shared/utils/global.utils';
import { TaskTypes } from 'src/app/shared/models/tasks.model';
import { Params } from '@angular/router';
import { ArraySerializerBase } from './base/array.base';
import {
  QueryParamSerializer,
  QueryParamsKeys,
} from '../model/sidebar-query-params.model';

export class TaskTypesSelectionSerializer
  extends ArraySerializerBase<TaskTypes>
  implements QueryParamSerializer<TaskTypes[]>
{
  private static readonly allTaskTypes = objectValues(TaskTypes);

  public readonly key = QueryParamsKeys.sidebarTaskTypesSelection;

  keyIsIn(params: Params): boolean {
    return Object.hasOwn(params, this.key);
  }

  deserializeQueryParamValue(value: string): TaskTypes[] {
    const queryParamsListOfTaskTypes = this.deserialize(value);

    const legitTaskTypes: TaskTypes[] = [];
    const nonExistingTaskTypes: string[] = [];

    for (const potentialTaskType of queryParamsListOfTaskTypes) {
      if (
        TaskTypesSelectionSerializer.allTaskTypes.includes(
          potentialTaskType as TaskTypes
        )
      ) {
        legitTaskTypes.push(potentialTaskType as TaskTypes);
      } else {
        nonExistingTaskTypes.push(potentialTaskType);
      }
    }

    if (nonExistingTaskTypes.length > 0) {
      // Even if query params have some wrong data we don't want to prevent app to be functional
      console.warn(
        `query params for task types have non-existing types: ${nonExistingTaskTypes.join(', ')}`
      );
    }
    return legitTaskTypes;
  }

  serializeToQueryParamValue(value: TaskTypes[]): string {
    return this.serialize(value);
  }
}
